import { req } from "./transport";
import type { ConversationMessage } from "./types";

export const messagingApi = {
  // Increment 8: messaging
  async startThread(input: { toUserId: number; contextType?: string; contextId?: string; subject?: string; body: string; requestQuote?: boolean; bidId?: string }) {
    return req<{ threadId: string; message: any }>("/threads", { method: "POST", body: JSON.stringify(input) });
  },

  async directMessageEligibility(userId: number) {
    return req<{ canMessage: boolean }>(`/threads/direct-eligibility/${encodeURIComponent(userId)}`);
  },

  async listThreads(filter?: "active" | "archived", signal?: AbortSignal) {
    const qs = filter === "archived" ? "?filter=archived" : "";
    return req<{ threads: any[]; archivedCount: number }>(`/threads${qs}`, { signal }, { rejectUnauthorized: signal !== undefined });
  },

  // v3.9.14 — conversation management
  async archiveThread(id: string) {
    return req<{ ok: boolean; archived: boolean }>(`/threads/${encodeURIComponent(id)}/archive`, { method: "POST" });
  },

  async unarchiveThread(id: string) {
    return req<{ ok: boolean; archived: boolean }>(`/threads/${encodeURIComponent(id)}/unarchive`, { method: "POST" });
  },

  async deleteThread(id: string) {
    return req<{ ok: boolean; deleted: string }>(`/threads/${encodeURIComponent(id)}`, { method: "DELETE" });
  },

  async messagesUnreadCount() {
    const r = await req<{ count: number }>("/threads/unread-count");
    return r?.count ?? 0;
  },

  async getThread(id: string) {
    return req<{ thread: any; messages: ConversationMessage[] }>(`/threads/${encodeURIComponent(id)}`);
  },

  async postMessage(threadId: string, body: string) {
    return req<{ message: any }>(`/threads/${encodeURIComponent(threadId)}/messages`, { method: "POST", body: JSON.stringify({ body }) });
  }
};
